import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType } from '../types/translation-types';

export class GetPreviewContentUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(applicationType: ApplicationType, fileKey?: string): Promise<string> {
    return this.repository.getPreviewContent(applicationType, fileKey);
  }
}
